<mat-expansion-panel class="company-data-panel mat-elevation-z0" hideToggle [expanded]="expanded()" (opened)="expanded.set(true)" (closed)="expanded.set(false)">
  <mat-expansion-panel-header class="company-data-panel-header" collapsedHeight="auto" expandedHeight="auto">
    <div class="panel-header-content">
      <div class="panel-header-row">
        <div class="panel-header-title">
          <mat-icon>business</mat-icon>
          <span>{{ 'dataManagement.organizationSettings.sections.companyData' | transloco }}</span>
        </div>
        <mat-icon class="panel-chevron">{{ expanded() ? 'expand_less' : 'expand_more' }}</mat-icon>
      </div>
    </div>
  </mat-expansion-panel-header>

  <div class="identity-row">
    <div class="identity-field">
      <span class="field-label">{{ 'dataManagement.organizationSettings.fields.companyName' | transloco }}</span>
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-select">
        <input matInput [value]="organization().name" [attr.aria-label]="'dataManagement.organizationSettings.fields.companyName' | transloco" disabled />
      </mat-form-field>
    </div>

    @if (selfManufacturer() && isPPWRAllowed) {
      <div class="identity-field">
        <span class="field-label">{{ 'createDoc.createDocDialog.docProfileLabel' | transloco }}</span>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-select">
          <mat-select [value]="selfDocProfileId()" [attr.aria-label]="'createDoc.createDocDialog.docProfileLabel' | transloco" (selectionChange)="selfDocProfileId.set($event.value)">
            <mat-option [value]="noDocProfileId">{{ 'createDoc.createDocDialog.docProfileNone' | transloco }}</mat-option>
            @for (profile of docProfilesInput(); track profile.id) {
              <mat-option [value]="profile.id">{{ profile.profileName }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
  </div>

  <div class="form-grid" [formGroup]="organizationForm">
    <mat-form-field appearance="outline" class="span-12" subscriptSizing="dynamic">
      <mat-label>{{ 'dataManagement.organizationSettings.fields.streetAndHouseNumber' | transloco }}</mat-label>
      <input matInput formControlName="address" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="span-3" subscriptSizing="dynamic">
      <mat-label>{{ 'dataManagement.organizationSettings.fields.postalCode' | transloco }}</mat-label>
      <input matInput formControlName="postCode" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="span-6" subscriptSizing="dynamic">
      <mat-label>{{ 'dataManagement.organizationSettings.fields.city' | transloco }}</mat-label>
      <input matInput formControlName="city" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="span-3" subscriptSizing="dynamic">
      <mat-label>{{ 'dataManagement.organizationSettings.fields.country' | transloco }}</mat-label>
      <mat-select formControlName="location">
        @for (country of allCountries(); track country.futureId) {
          <mat-option [value]="country.futureId">
            {{ country.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="sticky-actions">
    <button mat-button type="button" [disabled]="!hasChanges() || isSaving()" (click)="cancelChanges()">
      {{ 'common.buttons.cancel' | transloco }}
    </button>
    <button mat-raised-button color="primary" type="button" [disabled]="!hasChanges() || isSaving()" (click)="saveChanges()">
      <mat-icon>save</mat-icon>
      {{ 'common.buttons.save' | transloco }}
    </button>
  </div>
</mat-expansion-panel>